export default __webpack_public_path__ + "static/media/JBK.15da435f.jpg";